import { Badge } from '@/components/ui/badge';

const STATUS_MAP = {
  scheduled: { label: 'Scheduled', variant: 'default' },
  in_progress: { label: 'In progress', variant: 'warning' },
  completed: { label: 'Completed', variant: 'success' },
  accepted: { label: 'Accepted', variant: 'success' },
  rejected: { label: 'Rejected', variant: 'destructive' },
  pending: { label: 'Pending', variant: 'warning' },
  cancelled: { label: 'Cancelled', variant: 'muted' },
  terminated: { label: 'Terminated', variant: 'destructive' },
  expired: { label: 'Expired', variant: 'muted' },
  disconnected: { label: 'Disconnected', variant: 'warning' },
  // Historical only — nothing sets this any more.
  no_show: { label: 'No show', variant: 'muted' },
};

export default function StatusBadge({ status, className }) {
  const key = String(status || '').toLowerCase().replace(/\s+/g, '_');
  const config = STATUS_MAP[key] || { label: status || 'Unknown', variant: 'muted' };
  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
